import React, { Component } from 'react';
import _ from 'lodash';

import Paper from 'material-ui/Paper';

import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import BridgeAppBar from './MainComponents/BridgeAppBar';
import clientsStore from '../stores/clientsStore';

// import _ from 'lodash';

const Command = ({command, onDelete, onEdit, onCopyAndCreate}) => (
    <Paper className="commandItem">
        <div style={{paddingLeft: "28px", marginBottom: "8px", color: command.executed === "1" ? "lightgreen" : "black"}}>Codigo de comando: { command.commandID } </div>
        <div><span><ChevronRight color={"#757575"} /></span> <span style={{
            verticalAlign: "top", fontSize: "18px", fontWeight: "300"
        }}>{ command.commandTarget } { command.commandArguments }</span> </div>
        <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Working directory:</span> { command.workingDirectory } </div>
        {/* <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Send output:</span> { command.sendOutput } </div> */}
        <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Output:</span> { command.output } </div>
        {/* <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Executed:</span> { command.executed } </div> */}
        {/* <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Enabled:</span> { command.enabled } </div> */}
        {/* <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Is error:</span> { command.isError } </div> */}
        {/* <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Execution time:</span> { command.executionTime } </div> */}
        <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Command date:</span> { command.commandDate } </div>
        <div style={{paddingLeft: "28px", marginTop: "-4px"}}> <span style={{fontWeight: "500"}}>Call date:</span> { command.callDate } </div>
    </Paper>
);

const CommandList = ({commands}) => (
    <div>
        {
            commands.map((item, index) =>(
                <Command 
                    key={index}
                    command={item}
                />
            ))
        }
    </div>
);

class Commands extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commands: [],
            clientName: ""
        }
    }

    componentDidMount() {
        clientsStore.getCommands({
            id: this.props.match.params.id,
            onSuccess: (response) => {
                ////console.warn("COMPONENT DID MOUNT, LOGS: " + JSON.stringify(response));
                let sortedResponse = _.orderBy(response, ["executed", "commandDate", "commandID"], ["asc", "desc", "desc"]);
                this.setState({commands: sortedResponse});
            }
        });
        clientsStore.getClients({
            id:this.props.match.params.id,
            onSuccess: (response) => {
                this.setState({clientName: response.clientName});
            }
        });
    }
    render() {
        return (
            <div>
                <BridgeAppBar 
                    toClient={{ url: "/clientdetails/" + this.props.match.params.id, display: this.state.clientName }} 
                    toStoredCommands={"/storedcommands/" + this.props.match.params.id} 
                    toCommands={"/commands/" + this.props.match.params.id} 
                    toLogs={"/logs/" + this.props.match.params.id} 
                />
                <h1 style={{textAlign:'center'}}>Comandos de {this.state.clientName} </h1><br />
                <CommandList commands={this.state.commands}/>
            </div>
        );
    }
}

export default Commands;


// WEBPACK FOOTER //
// ./src/components/Commands.js